import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgFile = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M5.348 5.25C5.348 4.007 6.34 3 7.565 3H13.3c.59 0 1.15.237 1.566.66l3.14 3.183c.415.421.647.991.647 1.589V18.75c0 1.241-.994 2.25-2.217 2.25h-8.87c-1.224 0-2.217-1.009-2.217-2.25zm11.641 13.5V8.625h-2.772A1.116 1.116 0 0 1 13.11 7.5V4.688H7.565a.56.56 0 0 0-.554.562v13.5c0 .31.248.563.554.563h8.87a.56.56 0 0 0 .554-.563"
    }));
export default SvgFile;
